import { defineStore } from 'pinia'
import { authAPI, syncAPI } from '../services/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
    isAuthenticated: false,
    loading: false,
    error: null,
    monarchNeedsReauth: false
  }),

  actions: {
    async login() {
      try {
        this.loading = true
        this.error = null

        const response = await authAPI.login()
        const { authorization_url } = response.data

        // Redirect to Google OAuth
        window.location.href = authorization_url
      } catch (error) {
        this.error = error.response?.data?.error || 'Login failed'
        throw error
      } finally {
        this.loading = false
      }
    },

    async handleCallback(token) {
      try {
        this.token = token
        localStorage.setItem('token', token)
        await this.fetchUser()
      } catch (error) {
        this.error = error.response?.data?.error || 'Authentication failed'
        throw error
      }
    },

    async fetchUser() {
      try {
        const response = await authAPI.getMe()
        this.user = response.data.user
        this.isAuthenticated = true
        this.checkMonarchStatus()
      } catch (error) {
        this.logout()
        throw error
      }
    },

    async checkMonarchStatus() {
      try {
        const response = await syncAPI.getMonarchStatus()
        this.monarchNeedsReauth = response.data.needs_reauth || false
      } catch (error) {
        console.error('Error checking Monarch status:', error)
      }
    },

    setMonarchNeedsReauth() {
      this.monarchNeedsReauth = true
    },

    clearMonarchReauth() {
      this.monarchNeedsReauth = false
    },

    async logout() {
      try {
        await authAPI.logout()
      } catch (error) {
        console.error('Logout error:', error)
      } finally {
        this.user = null
        this.token = null
        this.isAuthenticated = false
        localStorage.removeItem('token')
      }
    },

    async refreshToken() {
      try {
        await authAPI.refreshToken()
      } catch (error) {
        this.logout()
        throw error
      }
    },

    async checkAuth() {
      if (this.token) {
        try {
          await this.fetchUser()
        } catch (error) {
          this.logout()
        }
      }
    }
  }
})
